export default __webpack_public_path__ + "static/media/1008.8f955ae1.png";